import * as React from "react";
const SvgBlend = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx={9} cy={9} r={7} /><circle cx={15} cy={15} r={7} /></svg>;
export default SvgBlend;